import { NewsCategory } from '@/constants/categories';
import { apiClient } from './client';

export const GETv1NewsCategory = (
  category: NewsCategory,
  params?: {
    limit?: number;
    startAt?: number;
    endAt?: number;
  }
) => {
  const url = `/media/api/v1/newslist/category/${category}`;

  return apiClient.get(url, params);
};
